import React, { useRef } from "react";
import { ListBox, ListBoxItem, Popover, Button } from "react-aria-components";
import { Avatar, Text } from "ui-components";

import { UserEntity } from "@/src/hooks/api/generated";
import { useChat } from "@/src/hooks/useChat";
import { useChatFunctions } from "@/src/hooks/useChatFunctions";
import { useNavigate } from "@/src/hooks/useNavigate";

export function ChatBoxSuggestionList({
  isOpenSuggestion,
  suggestUsers,
  searchConnectionForChatStatus,
  handleIsOpenSuggestion,
}: {
  isOpenSuggestion: boolean;
  suggestUsers: UserEntity[];
  searchConnectionForChatStatus: "error" | "idle" | "pending" | "success";
  handleIsOpenSuggestion: (value: boolean) => void;
}): JSX.Element {
  const triggerRef = useRef(null);
  const { pushQueryParam } = useNavigate();

  const { chatMetaData, setMessages } = useChat();
  const { changeSearchConnectionStatus, setSelectedConversationByUserData } =
    useChatFunctions();

  function onSelectUserFromSearchList(user: UserEntity): void {
    pushQueryParam({
      key: "recipient",
      value: user?.id.toString(),
    });
    setMessages?.(undefined);
    setSelectedConversationByUserData(user);
    changeSearchConnectionStatus(false);
  }
  return (
    <div>
      {chatMetaData.isSearchConnectionOpen && (
        <div className="relative left-10" ref={triggerRef}>
          <Popover
            className="absolute"
            triggerRef={triggerRef}
            placement="bottom left"
            offset={0}
            onOpenChange={(value) => handleIsOpenSuggestion(value)}
            isOpen={isOpenSuggestion}
          >
            {suggestUsers.length === 0 &&
            searchConnectionForChatStatus === "success" ? (
              <div className="absolute z-10 w-80 bg-white shadow border p-2 rounded-br rounded-bl border-t-0">
                <Text>No connections found.</Text>
              </div>
            ) : (
              <ListBox
                className="w-80 bg-white shadow border p-2 rounded-br rounded-bl border-t-0"
                selectionMode="single"
              >
                {/* Mapping over suggested users */}
                {suggestUsers?.map((item) => (
                  <ListBoxItem
                    id={item.id.toString()}
                    key={item.id.toString()}
                    className="cursor-pointer my-2 p-1 outline-none"
                  >
                    {/* Button to select a user and start a new chat */}
                    <Button
                      className="flex flex-start outline-none w-full"
                      onPress={() => {
                        onSelectUserFromSearchList(item);
                      }}
                    >
                      <div className="flex flex-row gap-2 items-center justify-center">
                        <Avatar
                          src={item?.userTaxonomy?.image?.public_id}
                          alt={`${item.first_name} profile images`}
                          size="xxs"
                        />
                        <Text>
                          {item.first_name} {item.last_name}
                        </Text>
                      </div>
                    </Button>
                  </ListBoxItem>
                ))}
              </ListBox>
            )}
          </Popover>
        </div>
      )}
    </div>
  );
}
